import { FC } from 'react';
import CustomLoading from '../../CustomLoading';
import { useSharesTransferModal } from './context/SharesTransferModalContext';

import SharesTransferModalHeader from './components/SharesTransferModalHeader';
import SharesTransferModalBody from './components/SharesTransferModalBody';
import SharesTransferModalFooter from './components/SharesTransferModalFooter';

import '../Modals.scss';

const SharesTransferModal: FC = () => {
  const { data } = useSharesTransferModal();

  return (
    <>
      <SharesTransferModalHeader />
      <SharesTransferModalBody />
      <SharesTransferModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default SharesTransferModal;
